import { parse } from 'graphql';

export const ReorderAddressDataDocument = parse(`
  query ReorderAddressData($transactionId: String!) {
      orderByTransactionId(transaction_id: $transactionId) {
          phone
          leave_message
          send_sms
          address {
            customer_address_street
            customer_address_city
            customer_address_state
            customer_address_zip
          }
          tests {
            test_id
            customer_tests_type
          }
      }
    }
`);
